import { useMemo } from 'react';
import { useFeatureFlags } from './useFeatureFlags';
import { useGlobalDialog } from './useGlobalDialog';
import { GlobalDialogTypes } from '../type';

export const useRouteLogic = () => {
  const { dailyTipperEnabled, cookiesEnabled, me, userSettings } = useFeatureFlags();

  const { data: dataGlobalDialog } = useGlobalDialog();

  const shouldShowDailyTipper = useMemo(() => {
    return (
      dailyTipperEnabled &&
      ((cookiesEnabled && userSettings?.isCookieAccepted) || !cookiesEnabled) &&
      (!dataGlobalDialog?.dialogId || dataGlobalDialog?.dialogId === GlobalDialogTypes.DAILY_TIPPER)
    );
  }, [dailyTipperEnabled, cookiesEnabled, userSettings, dataGlobalDialog]);

  const shouldRedirectToConfirmEmail = useMemo(() => {
    const query = new URLSearchParams(window.location.search);
    return me?.confirmationToken && window.location && !query.get('token');
  }, [me]);

  return {
    shouldShowDailyTipper,
    shouldRedirectToConfirmEmail,
  };
};
